import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import React from 'react'
import type { LocationIssue } from '../mockLocationDetails'

const IssuePanel = ({ issue }: { issue: LocationIssue }) => {
  const [css] = useStyletron()
  const isError = issue.level === 'error'
  const bg = isError ? palette.cayenne10 : palette.eggYolk10
  const iconColor = isError ? palette.cayenne50 : palette.eggYolk50
  const iconClass = isError ? 'fa-exclamation-circle' : 'fa-flag'
  return (
    <div
      className={`d-flex align-items-center p-m mb-m ${css({
        backgroundColor: bg,
        borderRadius: '4px',
      })}`}
    >
      {/* Decorative — the visible text in `issue.source` already states
        the severity, so the icon should not announce it again. */}
      <i
        className={`fa ${iconClass} mr-m ${css({
          color: iconColor,
          fontSize: '20px',
        })}`}
        aria-hidden="true"
      />
      <div className="flex-grow-1">
        <p
          className={`bold body-text-4 ${
            issue.description ? 'mb-xxs' : 'mb-0'
          } ${css({
            color: palette.grey90,
          })}`}
        >
          {issue.title}
        </p>
        {issue.description && (
          <p className={`body-text-4 mb-0 ${css({ color: palette.grey70 })}`}>
            {issue.description}
          </p>
        )}
      </div>
      <p className={`body-text-4 mb-0 ml-m ${css({ color: palette.grey70 })}`}>
        {issue.source}
      </p>
    </div>
  )
}

export default IssuePanel
